import { render, staticRenderFns } from "./PromoBannerAprils.vue?vue&type=template&id=45864d5b&scoped=true&"
import script from "./PromoBannerAprils.vue?vue&type=script&lang=js&"
export * from "./PromoBannerAprils.vue?vue&type=script&lang=js&"
import style0 from "./PromoBannerAprils.vue?vue&type=style&index=0&id=45864d5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45864d5b",
  null
  
)

export default component.exports